import axios from 'axios'
import { jsonConfig } from '../Config'
// import Cookies from 'js-cookie'

const functions = {
    formatCpf: (cpf) => {
        return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")

    }
}

const conection = {

    auth: () => {
        const instance = axios.create(
            {
                baseURL: `${jsonConfig.urlAPI}/admin`,
                withCredentials: true,
                headers: {
                    "proxyauthorization": jsonConfig.APIKEY

                }
            }
        )
        instance.interceptors.request.use(async (config) => {
            const method = config.method?.toUpperCase();
            if (['POST', 'PUT', 'DELETE', 'PATCH'].includes(method)) {
                // busca o token csrf antes da requisição
                const { data } = await axios.get(`${jsonConfig.urlAPI}/csrftoken`, {
                    withCredentials: true,
                    headers: {
                        "proxyauthorization": jsonConfig.APIKEY,

                    }
                });
                config.headers['X-CSRF-Token'] = data.csrfToken;
            }
            return config;
        }, error => {
            console.log(error)
            return Promise.reject(error);
        });

        return instance;
    },
    authInvestidor: () => {
        const instance = axios.create(
            {
                baseURL: `${jsonConfig.urlAPI}/investidor`,
                withCredentials: true,
                headers: {
                    "proxyauthorization": jsonConfig.APIKEY

                }
            }
        )
        instance.interceptors.request.use(async (config) => {
            const method = config.method?.toUpperCase();
            if (['POST', 'PUT', 'DELETE', 'PATCH'].includes(method)) {
                // busca o token csrf antes da requisição
                const { data } = await axios.get(`${jsonConfig.urlAPI}/csrftoken`, {
                    withCredentials: true,
                    headers: {
                        "proxyauthorization": jsonConfig.APIKEY,

                    }
                });
                config.headers['X-CSRF-Token'] = data.csrfToken;
            }
            return config;
        }, error => {
            console.log(error)
            return Promise.reject(error);
        });

        return instance;
    },
    noAuthInvestidor: () => {
        const instance = axios.create(
            {
                baseURL: `${jsonConfig.urlAPI}/investidor`,
                withCredentials: true,
                headers: {
                    "proxyauthorization": jsonConfig.APIKEY,

                }
            }
        )
        instance.interceptors.request.use(async (config) => {
            const method = config.method?.toUpperCase();
            if (['POST', 'PUT', 'DELETE', 'PATCH'].includes(method)) {
                // busca o token csrf antes da requisição
                const { data } = await axios.get(`${jsonConfig.urlAPI}/csrftoken`, {
                    withCredentials: true,
                    headers: {
                        "proxyauthorization": jsonConfig.APIKEY,

                    }
                });
                config.headers['X-CSRF-Token'] = data.csrfToken;
            }
            return config;
        }, error => {
            console.log(error)
            return Promise.reject(error);
        });

        return instance;
    },
    noAuth: () => {
        const instance = axios.create(
            {
                baseURL: `${jsonConfig.urlAPI}/admin`,
                withCredentials: true,
                headers: {
                    "proxyauthorization": jsonConfig.APIKEY,

                }
            }
        )
        instance.interceptors.request.use(async (config) => {
            const method = config.method?.toUpperCase();
            if (['POST', 'PUT', 'DELETE', 'PATCH'].includes(method)) {
                // busca o token csrf antes da requisição
                const { data } = await axios.get(`${jsonConfig.urlAPI}/csrftoken`, {
                    withCredentials: true,
                    headers: {
                        "proxyauthorization": jsonConfig.APIKEY,

                    }
                });
                config.headers['X-CSRF-Token'] = data.csrfToken;
            }
            return config;
        }, error => {
            console.log(error)
            return Promise.reject(error);
        });

        return instance;
    }
}

const truncate = (str, n) => {
    return (str.length > n) ? str.substr(0, n - 1) + '...' : str;
};

const formatCpf = (cpf) => {
    return cpf?.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")

}


export { functions, conection, truncate, formatCpf }